// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__v0IHB","top":"styles_top__3Zh_e","left":"styles_left__2boBH","description":"styles_description__1O1RP"};